import { render } from "./SiteDomains.vue?vue&type=template&id=45f334c9"
import script from "./SiteDomains.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteDomains.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteDomains.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45f334c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45f334c9', __exports__)) {
    api.reload('45f334c9', __exports__)
  }
  
  module.hot.accept("./SiteDomains.vue?vue&type=template&id=45f334c9", () => {
    api.rerender('45f334c9', render)
  })

}


export default __exports__